// extracted by mini-css-extract-plugin
export default {"vacancies-page":"VacancyPage_vacancies-page__eBI5R","vacancies-title":"VacancyPage_vacancies-title__XR1I3"};